import { render, staticRenderFns } from "./MypageSwitchToPaidPlanPane.vue?vue&type=template&id=1b7ae4fe&scoped=true"
import script from "./MypageSwitchToPaidPlanPane.vue?vue&type=script&lang=ts"
export * from "./MypageSwitchToPaidPlanPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageSwitchToPaidPlanPane.vue?vue&type=style&index=0&id=1b7ae4fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ae4fe",
  null
  
)

export default component.exports